module.exports = __webpack_public_path__ + "static/media/Prompt-Semibold.ba9b20ec.ttf";